/* eslint-disable no-console */
import { getToken } from 'firebase/app-check';

import { appCheck } from '@portal/services/firebase';

export type LoginIntegrityPayload = {
  platform: 'web';
  firebaseAppCheckToken: string;
};

export const prepareIntegrity = async (): Promise<void> => {
  if (!appCheck) return;
  try {
    await getToken(appCheck, false);
  } catch {
    return;
  }
};

export const getIntegrityTokenOrAssertionForLogin = async (
  forceRefresh = false
): Promise<LoginIntegrityPayload | null> => {
  if (!appCheck) {
    if (import.meta.env.DEV) {
      console.warn(
        '[AppIntegrity] Firebase App Check not initialized. Set VITE_FIREBASE_RECAPTCH_APIKEY and enable App Check in Firebase Console, or use APP_INTEGRITY_SKIP_CLIENT_IDS on the backend for this client.'
      );
    }
    return null;
  }
  try {
    const { token } = await getToken(appCheck, forceRefresh);
    if (!token) return null;
    return { platform: 'web', firebaseAppCheckToken: token };
  } catch (err: unknown) {
    if (import.meta.env.DEV) {
      console.warn('[AppIntegrity] getToken failed:', err);
      const code =
        err && typeof err === 'object' && 'code' in err
          ? String((err as { code: string }).code)
          : '';
      if (
        code === 'appCheck/fetch-status-error' ||
        (err instanceof Error && err.message?.includes('403'))
      ) {
        console.warn(
          '[AppIntegrity] Register the debug token in Firebase Console: App Check → your web app (⋮) → Manage debug tokens → Add the token shown in the console on first load.'
        );
      }
    }
    return null;
  }
};

export const setIntegrityHeaders = (
  setHeader: (key: string, value: string) => void,
  payload: LoginIntegrityPayload
): void => {
  if (payload.platform === 'web' && payload.firebaseAppCheckToken) {
    setHeader('X-Firebase-AppCheck', payload.firebaseAppCheckToken);
  }
};
